import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../components/loader";
import { useAuth0 } from "@auth0/auth0-react";

import { toast } from "react-toastify";

let toastOptions = {
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

const OutsideOrgAdminRoute = ({ component, ...args }) => {
  const { user, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const userRoles = user && user["https://new.evojets.com/roles"];

  const outsideOrg =
    user &&
    user["https://new.evojets.com/outsideOrganization"] &&
    userRoles.some((role) => "Organization Admin" === role);

  const checkToken = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
    });
  };

  // useEffect(() => {
  //   console.log("EFFECT RUNNING");
  //   checkToken();
  // });

  if (outsideOrg) {
    return (
      <Route
        component={withAuthenticationRequired(component, {
          onRedirecting: () => <Loader />,
        })}
        {...args}
      />
    );
  }
  toast.error("Unauthorized!", toastOptions);
  return <Redirect to="/" />;
};

export default OutsideOrgAdminRoute;
